/* MUI */
import { Box } from '@auviknetworks/iceberg-ui';
import { Checkbox } from '@mui/material';
import { Row } from '@tanstack/react-table';

/*  React  */
import React from 'react';

/**
 * A React component that renders a checkbox cell for row selection in a table.
 * @returns {React.ReactElement} The rendered table cell component.
 * @param {Object} props.row - The row object containing selection state and handlers.
 * @param {Function} props.row.getIsSelected - Function that returns whether the row is selected.
 * @param {Function} props.row.getCanSelect - Function that returns whether the row can be selected.
 * @param {Function} props.row.getToggleSelectedHandler - Function that returns the change handler for toggling selection.
 *
 * @returns {React.ReactElement} A checkbox component for row selection.
 */

export const SelectRowCell = <TData,>({
    row
}: {
    row: Row<TData>;
}): React.ReactElement => (
    <Box display="flex" justifyContent="space-between">
        <Checkbox
            checked={row.getIsSelected()}
            disabled={!row.getCanSelect()}
            onChange={row.getToggleSelectedHandler()}
            sx={{
                '&.MuiCheckbox-root': { width: 'unset' },
                padding: 0
            }}
        />
    </Box>
);
